export default __webpack_public_path__ + "static/nathan-sanders-teal-ee157b0fa027322fb98783f40295a438.png";